export default __webpack_public_path__ + "static/media/SurveyWelcome.4e461237.png";